import type { ReactNode } from 'react'
import type { UseFormReturn } from 'react-hook-form'

import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form'
import { Input } from '@/components/ui/input'

import type { AgentNodeFormSchemaType } from '../agency-node-form.schema'

interface AgentNodeNameFieldProps {
  form: UseFormReturn<AgentNodeFormSchemaType>
}

export const AgentNodeNameField = ({ form }: AgentNodeNameFieldProps): ReactNode => (
  <FormField
    control={form.control}
    name="label"
    render={({ field }) => (
      <FormItem>
        <FormLabel>Agent Name</FormLabel>
        <FormControl>
          <Input placeholder="Enter agent name" className="agent-node-name-input" {...field} />
        </FormControl>
        <FormMessage />
      </FormItem>
    )}
  />
)

AgentNodeNameField.displayName = 'AgentNodeNameField'
